import store from 'store';
import axios, { CancelTokenSource } from 'axios';
import createFootprintFlightApi from 'api/flightFootprint';

const CancelToken = axios.CancelToken;
let source: CancelTokenSource = CancelToken.source();

interface Data {
  partnershipId: string;
  jobId: string;
  context: PortalContext;
  module: 'flightOffset' | 'airFreight';
  setFileProcessingCb: (state: boolean) => void;
  setFileUploadingCb: (state: boolean) => void;
  setProgressPercentageCb: (percentage: number) => void;
}

const checkJob = async <T>(data: Data): Promise<JobStatusResponse<T>> => {
  const { getState } = store;
  const { partnershipId, jobId, context, module, setFileProcessingCb, setFileUploadingCb, setProgressPercentageCb } = data;
  const isUploadingFileCancelled = getState()[module].isUploadingFileCancelled;
  const flightAPI = createFootprintFlightApi(context);
  source = CancelToken.source();
  let response = await flightAPI.getJobStatus<T>(partnershipId, jobId, source.token);
  if (!isUploadingFileCancelled) {
    setFileProcessingCb(response?.status === 'Created');
    setFileUploadingCb(response.status === 'Started');
    setProgressPercentageCb(response.progressPercentage);
  }
  if ((response.status === 'Created' || response.status === 'Started') && !isUploadingFileCancelled) {
    await new Promise(resolve => {
      setTimeout(async () => {
        response = await checkJob(data);
        resolve(response);
      }, 1000);
    });
  }
  return response;
};

export default checkJob;
